import PropTypes from 'prop-types';

import { Box } from '@mui/material';

import SortableTableComponent from '../../Table/SortableTableComponent';

import { confirmDeleteGuest } from '../actions';

import { TABLE_ID } from '../../Table/constants';

import StyledExpanderLine from '../../Forms/StyledExpanderLine';
import ListActions from '../../Table/ListActions';

const AdditionalGuestsComponent = (props) => {
  const { original, dispatch, theme, queryParams } = props;

  const guests = original?.guests;

  if (!guests?.length) return <Box p="2rem">No guests</Box>;

  const columns = [
    {
      Header: 'Guest',
      id: 'guest',
      sortable: true,
      accessor: ({ attendeeName }) => attendeeName,
    },
    {
      Header: 'Role',
      id: 'role',
      sortable: true,
      accessor: () => 'Guest',
    },

    {
      Header: 'Action',
      id: 'action',
      sortable: false,
      width: 120,
      accessor: ({ id }) => {
        const actions = [
          {
            label: 'Remove',
            color: theme.palette.secondary.main,
            onClick: () =>
              confirmDeleteGuest(dispatch, original?.id, id, queryParams),
          },
        ];

        return (
          <ListActions
            color={theme.palette.primary.main}
            actions={actions}
            isFullWidth
          />
        );
      },
    },
  ];

  return (
    <StyledExpanderLine>
      <SortableTableComponent
        tableId={TABLE_ID.eventRsvpsGuests}
        title="Guests"
        onLoad={() => {}}
        columns={columns}
        entries={guests}
        hideFilterInput
      />
    </StyledExpanderLine>
  );
};

AdditionalGuestsComponent.propTypes = {
  original: PropTypes.instanceOf(Object).isRequired,
  theme: PropTypes.instanceOf(Object).isRequired,
  dispatch: PropTypes.instanceOf(Object).isRequired,
  queryParams: PropTypes.instanceOf(Object).isRequired,
};
export default AdditionalGuestsComponent;
